export default "__VITE_PUBLIC_ASSET__70068e5e__"